// extracted by mini-css-extract-plugin
module.exports = {"PageNotFound":"PageNotFound_PageNotFound__2H4O4"};